<template>
  <div class="examInfo-card">
    <div class="left">
      <div class="img-box">
        <img :src="content.picture_url">
      </div>
    </div>
    <div class="right">
      <div class="text-header">
        <div class="title-wrap">
          <div class="tags">
          </div>
          <p class="title">{{content.name}}</p>
        </div>
        <div class="button-wrap">
          <router-link :to="`/course/edit/${content.id}`">
            <el-button type="primary">编辑基本信息</el-button>
          </router-link>
        </div>
      </div>
      <div class="text-main">
        <div class="time">
          有效期：
          <span>{{$moment(content.start_time).format('YYYY.MM.DD')}}-{{$moment(content.end_time).format('YYYY.MM.DD')}}</span>
        </div>
        <div v-if="content.teachers&&content.teachers.length">
          <span class="school-name">随堂老师：</span>
          <span class="subject-name">{{formateTeacher()}}</span>
        </div>
      </div>
      <div class="text-footer">
        <div class="price-wrap">
          <p class="old-price">¥{{content.market_price}}</p>
          <div>
            <span class="new-price">¥{{content.price}}</span>
          </div>
        </div>
        <div class="text-wrap">
          <div class="course-num">
            <p>{{content.hours || 0}}</p>
            <span>课时数</span>
          </div>
          <div class="member-num">
            <p>{{content.user_count}}位</p>
            <span>研友在学</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {}
  },
  methods: {
    formateTeacher() {
      let arr = this.content.teachers.filter((v) => { return v.type == 1 })
      return arr.map((v => { return v.name })).join(',')
    }
  }
}
</script>

<style lang="less" scoped>
.examInfo-card {
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 20px;
  overflow: hidden;

  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;

    .img-box {
      margin-right: 15px;
    }
    img {
      width: 340px;
      height: 180px;
      object-fit: cover;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;

    .text-header {
      display: flex;
      margin-bottom: 15px;

      .title-wrap {
        flex: 1;
      }
      .tag {
        font-size: 12px;
        color: #fff;
        background: #0091ff;
        border-radius: 5px;
        padding: 2px 5px;
        margin-right: 10px;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
      }
      .button-wrap {
        display: flex;
        justify-content: flex-end;
        margin-left: 20px;
      }
    }
    .text-main {
      .time {
        margin-bottom: 10px;
        font-weight: 800;
        span {
          font-weight: 400;
        }
      }
      .school-name {
        font-weight: 800;
      }
      .subject-name {
        /*   font-weight: bold; */
      }
    }
    .text-footer {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: 20px;

      .price-wrap {
        flex: 1;
      }
      .old-price {
        font-weight: bold;
        color: #999;
        text-decoration: line-through;
      }
      .new-price {
        font-weight: bold;
        color: #ff6600;
      }
      .member-price {
        font-size: 12px;
        color: #fff;
        padding: 2px 10px;
        background: #0091ff;
        border-radius: 5px;
        margin-left: 5px;
      }
      .text-wrap {
        display: flex;
        justify-content: center;
        align-items: center;

        & > div {
          text-align: center;
          padding: 0 30px;
        }
        p {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
      .member-num {
        border-left: 1px solid #ccc;
      }
    }
  }
}
</style>
